
import { useEffect, RefObject } from 'react';

interface UseAutoResizeTextareaProps {
  textareaRef: RefObject<HTMLTextAreaElement>;
  value: string;
  minHeight?: number;
  maxHeight?: number;
}

export const useAutoResizeTextarea = ({
  textareaRef,
  value,
  minHeight = 40,
  maxHeight = 240 // ~10 lines at standard line height
}: UseAutoResizeTextareaProps) => {
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = 'auto';
    
    // Calculate the new height based on content
    const scrollHeight = textarea.scrollHeight;
    
    // Apply height constraints
    const newHeight = Math.max(minHeight, Math.min(maxHeight, scrollHeight));
    
    // Set the new height
    textarea.style.height = `${newHeight}px`;
    
    // Enable overflow if content exceeds max height
    textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [value, minHeight, maxHeight, textareaRef]);
};
